import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import 'react-block-ui/style.css';
import SignalRService from '../../controllers/SignalRService';

class ChangeEmailPassword extends Component {

    constructor(props) {
        super(props)

        this.state = {
            newPwd: "",
            isEmptyNewPwd: false,
            oldAndNewMatch: false,
            invalidPwdPolicy: false,
            cnfpwd: ""
        }

        this.setNewPwd = this.setNewPwd.bind(this);
        this.setCnfPwd = this.setCnfPwd.bind(this);
        this.changePwd = this.changePwd.bind(this);
    }

    setCnfPwd(e) {
        e.preventDefault();
        this.setState({
            cnfpwd: e.target.value,
            doesNotMatchNewPwd: e.target.value !== this.state.newPwd
        });
    }

    setNewPwd(e) {
        e.preventDefault();
        this.setState({
            newPwd: e.target.value,
            isEmptyNewPwd: e.target.value === null || (e.target.value !== null && e.target.value.trim() === ""),
            doesNotMatchNewPwd: e.target.value !== this.state.cnfpwd,
            invalidPwdPolicy: !new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z][^*]{8,}$/).test(e.target.value)
        });
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    changePwd = e => {
        let isEmptyNewPwd = this.state.newPwd === null || (this.state.newPwd !== null && this.state.newPwd.trim() === ""),
            doesNotMatchNewPwd = this.state.newPwd !== this.state.cnfpwd,
            invalidPwdPolicy = !new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z][^*]{8,}$/).test(this.state.newPwd);

        if (!isEmptyNewPwd && !doesNotMatchNewPwd && !invalidPwdPolicy) {
            let data = {
                "extension": this.props.extension,
                "userId": this.props.userId,
                "newPassword": this.state.newPwd,
            };

            SignalRService.setMailPassword(data);
            this.props.toggleModal();
        } else {
            this.setState({
                isEmptyNewPwd: isEmptyNewPwd,
                doesNotMatchNewPwd: doesNotMatchNewPwd,
                invalidPwdPolicy: invalidPwdPolicy
            });
        }
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone("envelope")} /> {this.props.t("changepasswordemail")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <Form>
                                    <Form.Group className="mb-4" controlId="fcnewpwd" hasValidation>
                                        <Form.Label >{this.props.t("newpwd")}</Form.Label>
                                        <Form.Control type="password" value={this.state.newPwd} onChange={this.setNewPwd} isInvalid={this.state.isEmptyNewPwd || this.state.oldAndNewMatch || this.state.invalidPwdPolicy} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>
                                        {
                                            (this.state.isEmptyNewPwd) &&
                                            <Form.Text className='text-danger'>
                                                {this.props.t("newpasswordisempty")}
                                            </Form.Text>
                                        }
                                        {
                                            (this.state.invalidPwdPolicy) &&
                                            <Form.Text className='text-danger'>
                                                {this.props.t("newpwdmismatchpolicy")}
                                            </Form.Text>
                                        }
                                    </Form.Group>
                                    <Form.Group className="mb-4" controlId="fccnfpwd" hasValidation>
                                        <Form.Label>{this.props.t("cnfpwd")}</Form.Label>
                                        <Form.Control type="password" value={this.state.cnfpwd} onChange={this.setCnfPwd} isInvalid={this.state.doesNotMatchNewPwd} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>
                                        {
                                            (this.state.doesNotMatchNewPwd) &&
                                            <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                {this.props.t("passworddoesnotmatch")}
                                            </Form.Text>
                                        }
                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.changePwd}>
                            <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

export default withTranslation()(ChangeEmailPassword);